import React, { Fragment } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import TYPE from "../../../../../../constant/TYPE";
import KeypadShowButton from "../../../../learning/presentational/body/input/KeypadShowButton";
import NumberKeypad from "../../../../learning/presentational/body/input/numberKeypad/NumberKeypad";
import CalculationKeypad from "../../../../learning/presentational/body/input/calculationKeypad/CalculationKeypad";
import ComplexCalculationKeypad from "../../../../learning/presentational/body/input/complexCalculationKeypad/ComplexCalculationKeypad";
import Notepad from "../../../../learning/presentational/body/input/notepad/Notepad";
import SubmitButtons from "./numberKeypad/submitButtons/SubmitButtons";
import NotepadChangeButton from "./numberKeypad/submitButtons/NotepadChangeButton";
import KeypadChangeButton from "./notepad/submitButtons/KeypadChangeButton";
import AnswerEditor from "../../../../learning/presentational/body/input/AnswerEditor";
import PassButton from "./PassButton";
import HackleNoteBtn from "../../../../../common/HackleNoteBtn";
import AiTestMultipleChoiceQuestion from "../../../../learning/presentational/body/input/multipleChoiceQuestionKeypad/AiTestMultipleChoiceQuestion";
import MultipleChoiceQuestionKeypad from "../../../../learning/presentational/body/input/multipleChoiceQuestionKeypad/MultipleChoiceQuestionKeypad";

const Input = ( props ) => {

  const deviceInfo = useSelector( state => state.deviceInfo );
  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const useInfo = useSelector( state => state.user.info );

  const {
    KeypadShower,
    KeyPresser,
    KeyClicker,
    NoteTaker,
    AnswerEditorController,
    Submitter,
    QuestionPassor,
    children,
    ...PROPS
  } = props;

  const KEYPAD_SUBMIT_BUTTONS = <Submitter><SubmitButtons><NotepadChangeButton /></SubmitButtons></Submitter>;
  const NOTEPAD_SUBMIT_BUTTONS = <Submitter><SubmitButtons><KeypadChangeButton /></SubmitButtons></Submitter>;

  const KEYPAD = {
    [ TYPE.KEYPAD.NUMBER ] : <KeyClicker { ...PROPS }><NumberKeypad>{ KEYPAD_SUBMIT_BUTTONS }</NumberKeypad></KeyClicker>,
    [ TYPE.KEYPAD.CALCULATION ] : <KeyClicker { ...PROPS }><CalculationKeypad>{ KEYPAD_SUBMIT_BUTTONS }</CalculationKeypad></KeyClicker>,
    [ TYPE.KEYPAD.COMPLEX_CALCULATION ] : <KeyClicker { ...PROPS }><ComplexCalculationKeypad>{ KEYPAD_SUBMIT_BUTTONS }</ComplexCalculationKeypad></KeyClicker>,
    [ TYPE.KEYPAD.NOTE ] : <NoteTaker { ...PROPS }><Notepad>{ NOTEPAD_SUBMIT_BUTTONS }</Notepad></NoteTaker>,
    [ TYPE.KEYPAD.MULTIPLE ]: <AiTestMultipleChoiceQuestion {...PROPS}><MultipleChoiceQuestionKeypad /></AiTestMultipleChoiceQuestion>
  };

  return (
    <div className={ clsx( 
      'learningTail', 
      TYPE.DEVICE.PAD === deviceInfo.type && answeringQuestions.isShowKeypad && 'on' ,
      (answeringQuestions.data.objctYn === 'Y') && 'multiple'
      ) 
    }>
      <div className={ clsx( 'onlyButtonBox', ! answeringQuestions.isShowKeypad && 'active' ) }>
        { ! answeringQuestions.isShowKeypad && <KeypadShower><KeypadShowButton className="btn-green" { ...PROPS } /></KeypadShower> }
      </div>
      <KeyPresser { ...PROPS }>
        {
          answeringQuestions.data.objctYn === 'Y'
            ? answeringQuestions.isShowKeypad && KEYPAD[TYPE.KEYPAD.MULTIPLE]
            : answeringQuestions.isShowKeypad && KEYPAD[answeringQuestions.keypadType]
        }
      </KeyPresser>
      { answeringQuestions.isShowKeypad && <AnswerEditorController><AnswerEditor /></AnswerEditorController> }
      { answeringQuestions.isShowKeypad && <QuestionPassor><PassButton { ...PROPS } /></QuestionPassor>}
      { 
        useInfo.channelCode === TYPE.ENTRY_TYPE.GLOBAL01 && answeringQuestions.isShowKeypad && <HackleNoteBtn { ...PROPS } location='inputer'/>
      }
    </div>
  );

};

Input.defaultProps = {
  KeypadShower : Fragment,
  KeyPresser : Fragment,
  KeyClicker : Fragment,
  NoteTaker : Fragment,
  AnswerEditorController : Fragment,
  Submitter : Fragment,
  QuestionPassor : Fragment
};

export default Input;
